module.exports = __webpack_public_path__ + "static/media/order.js.2da6dbeb.map";